import React, { useState } from "react"
import { toast } from "react-toastify"
import FullScreen from "./FullScreen"
import Button from "./Button"
import { startDemoTour } from "../services/demoTour/demoTour.api"

/**
 * What a new sign up reads before the demo tour opens (Home's demo tour tile).
 *
 * @param open {Boolean}
 * @param onClose {function(): void}
 * @param days {Number} How long the tour lasts, or what is left of a running one
 * @param onRemoveTile {function(): void} "Remove tour tile": asks, then ends the tour for good
 */
const DemoTourWelcome = ({ open, onClose, days, onRemoveTile }) => {
    const [launching, setLaunching] = useState(false)

    const launch = () => {
        setLaunching(true)

        startDemoTour().catch((err) => {
            setLaunching(false)
            toast.error(err?.response?.data?.message || err?.message || "Sorry, the demo could not be opened.")
        })
    }

    return (
        <FullScreen
            style={{ zIndex: 99999 }}
            open={open}
            portal
            className="dna-dark dna-dark-bg x-fs-marketing-msg"
            onClose={onClose}
        >
            <div className="x-fs-marketing-msg-body" data-testid="demo-tour-welcome">
                <h2>Experience missionX fully loaded.</h2>
                <p>Explore a demo organization with data and see the possibilities.</p>
                <Button block disabled={launching} onClick={launch}>
                    Launch the demo site
                </Button>
                <p className="dna-light-text" style={{ marginTop: 30 }}>
                    PS this will be available for 7 days.
                </p>
                {onRemoveTile && (
                    <Button clear className="x-demo-tour-remove" onClick={onRemoveTile}>
                        Remove tour
                    </Button>
                )}
            </div>

            <div className="x-ac-bg right" style={{ backgroundImage: "url(themes/missions/bg-56.jpg)" }}></div>
        </FullScreen>
    )
}

export default DemoTourWelcome
